import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import SectionTitle from './SectionTitle';
import RadioButtonGroup from '../../../../../components/RadioButtonGroup';
// import PaginationWrapper from './PaginationWrapper';
// import CustomLightButton from './CustomLightButton';
import DeletableChip from '../../../../../components/DeletableChip';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';
import PaginationWrapper from '../../../../../components/PaginationWrapper';
import CustomLightButton from '../../../../../components/CustomLightButton';

export const SHOP_SELECTION_TYPES = {
    NO_RESTRICTIONS: 'NO_RESTRICTION_COMPANY',
    RESTRICTION_SHOP_WIDE: 'RESTRICTION_SHOP_WIDE',
};

class ShopSelectionSection extends Component {
    options = [
        { key: SHOP_SELECTION_TYPES.NO_RESTRICTIONS, label: 'Keine Einschränkung' },
        { key: SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE, label: 'Nur ausgewählte Shops' },
    ];

    normalize = (s) => (s ?? '').toString().toLowerCase().trim();

    getEligibleList = () => {
        const { shopList, selectedShops } = this.props;
        const list = Array.isArray(shopList) ? shopList : [];

        if (selectedShops == null) return list;

        const ids = Array.isArray(selectedShops) ? selectedShops.map((x) => x.id) : [];
        if (ids.length === 0) return [];

        const idSet = new Set(ids.map((x) => this.normalize(x)));

        return list.filter((shop) => {
            const sid = this.normalize(shop?.id ?? shop?.shopId);
            return idSet.has(sid);
        });
    };

    deleteShopById = (shopId) => {
        const { selectedShops, onShopSelectionChange, showAlert } = this.props;
        const mySelectedShops = [...(selectedShops ?? [])];

        const idx = mySelectedShops.findIndex((x) => (x?.id.toString() ?? x?.shopId.toString()) === shopId.toString());

        if (idx >= 0) {
            mySelectedShops.splice(idx, 1);
            onShopSelectionChange?.(mySelectedShops);
        } else {
            showAlert?.('Es ist mindestens ein Shop für die "Nur ausgewählte Shops" Option erforderlich.', ALERT_SEVERITY.ERROR);
        }
    };

    renderShopRow = (shop) => {
        const { selectedShops, editMode, showAlert } = this.props;

        const shopId = shop?.id ?? shop?.shopId;
        const selectedEntry = (selectedShops ?? []).find((x) => (x?.id ?? x?.shopId) === shopId);
        const isAdded = selectedEntry?.added;

        return (
            <DeletableChip
                key={`SHOP_${shopId}`}
                disabled={editMode && !isAdded}
                onDelete={() => this.deleteShopById(shopId)}
                showAlert={showAlert}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                    }}
                >
                    <Box>
                        <Typography sx={{ color: '#424242', fontWeight: 'bold', fontSize: 14 }}>
                            Name:
                        </Typography>
                        <Typography sx={{ color: '#424242', fontWeight: 'bold', fontSize: 14 }}>
                            Adresse:
                        </Typography>
                    </Box>

                    <Box>
                        <Typography sx={{ color: '#424242', fontSize: 14 }}>
                            {shop.name}
                        </Typography>
                        <Typography sx={{ color: '#424242', fontSize: 14 }}>
                            {shop.street} {shop.houseNumber}, {shop.zip} {shop.city}
                        </Typography>
                    </Box>
                </Box>
            </DeletableChip>
        );
    };

    render() {
        const {
            onShopSelectionPressed,
            selectionType,
            setSelectionType,
            editMode,
            showAlert,
            withoutTypeSelection
        } = this.props;

        const shouldShowShops =
            selectionType?.newType != null
                ? selectionType?.newType === SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE
                : selectionType?.type === SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE;

        const eligible = this.getEligibleList();

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/store.png')}
                    label="Shop-Auswahl"
                />
                {!withoutTypeSelection && (

                    <RadioButtonGroup
                        items={this.options}
                        selectedKey={selectionType?.newType != null ? selectionType?.newType : selectionType?.type}
                        onSelect={(key) => {
                            if (editMode) {
                                console.log("SHOP SELECTION CHANGE ATTEMPT IN EDIT MODE", { key, selectionType });
                                if (key === SHOP_SELECTION_TYPES.NO_RESTRICTIONS) {
                                    if (selectionType?.type !== SHOP_SELECTION_TYPES.NO_RESTRICTIONS) {
                                        setSelectionType?.({ ...selectionType, newType: key });
                                    }
                                } else if (
                                    selectionType?.newType === SHOP_SELECTION_TYPES.NO_RESTRICTIONS &&
                                    key === SHOP_SELECTION_TYPES.RESTRICTION_SHOP_WIDE
                                ) {
                                    setSelectionType?.({ type: key });
                                } else {
                                    showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                                }
                            } else {
                                setSelectionType?.({ type: key });
                            }
                        }}
                    />
                )}

                {(shouldShowShops || withoutTypeSelection) && (
                    <PaginationWrapper
                        items={eligible}
                        pageSize={5}
                        threshold={5}
                        disablePaginationOnSearch={true}
                        showSearch={eligible.length > 5}
                        filterFn={(shop, term) => {
                            const name = this.normalize(shop?.name ?? shop?.title ?? shop?.shopName);
                            const id = this.normalize(shop?.id ?? shop?.shopId);
                            return name.includes(term) || id.includes(term);
                        }}
                    >
                        {(pagedItems) =>
                            (pagedItems?.length ?? 0) > 0 ? (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {pagedItems.map(this.renderShopRow)}
                                </Box>
                            ) : null
                        }
                    </PaginationWrapper>
                )}

                {(shouldShowShops || withoutTypeSelection) && (
                    <CustomLightButton
                        icon={require('../../../../../assets/icons/store.png')}
                        label="Shop-Auswahl"
                        onPress={() => onShopSelectionPressed?.()}
                    />
                )}
            </Box>
        );
    }
}

export default ShopSelectionSection;